<template>
  <div>
    <div class="content-header">
      <div class="actions-blocks">
        <div v-for="field in textSearchFields" :key="field.id" class="actions-block">
          <input
            v-model="searchValues[field.field]"
            class="search-input"
            :placeholder="$tr(field.placeholder)"
            @keyup.enter="update_filters(field.id, searchValues[field.field])"
          />

          <div v-if="filters && filters[field.id]" class="search-btn delete">
            <div class="delete-term" @click="delete_search_value(field)"></div>
          </div>

          <div
            v-else
            class="search-btn search-btn-submit"
            @click="update_filters(field.id, searchValues[field.field])"
          >
            <i class="fa fa-search"></i>
          </div>
        </div>
      </div>

      <vbutton
        label="admin.recruiters.addManager"
        color="transparent"
        text_color="grey"
        icon="icon_plus"
        @click="toggle_add_user_modal(true)"
      />
    </div>

    <div class="admin-vacancies-scene">
      {{ filterCompany }}

      <recruiter-list
        v-if="!loading"
        :list="recruiters"
        :company-id="companyId"
        @sort_change="fetch"
      />

      <vpreloader v-else />

      <pagination
        v-if="!loading"
        :params="pagination"
        :on-limit-change="onLimitChange"
        :on-page-change="onPageChange"
      />
    </div>

    <invite-modal
      v-if="visible_add_user_modal"
      :is-success="isInviteModalSuccess"
      :title="$tr('admin.companies.inviteModal.userTitle')"
      @submit="inviteCompany"
      @close="toggle_add_user_modal(false)"
    />
  </div>
</template>

<script>
import axios from 'axios';
import { STORE_PREFIX } from '../constants.js';
import { mapGetters } from 'vuex';

import RecruiterList from '@/routes_new/inner/admin/company/recruiters/List';
import Pagination from '@/components/shared/Pagination';
import InviteModal from '@/routes_new/inner/admin/components/InviteModal';

export default {
  name: 'AdminRecruitersScene',

  components: {
    RecruiterList,
    Pagination,
    InviteModal
  },

  props: {
    filterCompany: Object,
    companyId: null,
    is_add_recruiter: Boolean
  },

  data() {
    return {
      visible_add_user_modal: false,
      isInviteModalSuccess: false,
      textSearchFields: [
        {
          id: 'search_term',
          field: 'search_name',
          placeholder: 'admin_console.companies.table.search_by_name'
        }
      ],

      searchValues: {
        search_name: '',
        email: ''
      }
    };
  },

  computed: {
    ...mapGetters(STORE_PREFIX + 'admin', {
      loading: 'recruiters/loading',
      recruiters: 'recruiters/list',
      filters: 'recruiters/filters',
      pagination: 'recruiters/pagination'
    }),

    currentUser() {
      return this.$store.getters['user/current'] || {};
    }
  },

  beforeMount() {
    this.fetch();

    if (this.is_add_recruiter) {
      this.visible_add_user_modal = true;
    }
  },

  methods: {
    fetch() {
      this.$store.dispatch(STORE_PREFIX + 'admin/recruiters/fetch', { company_id: this.companyId });
    },

    update_filters(id, value) {
      // console.log('update_filters id: ', id)
      // console.log('update_filters value: ', value)
      this.$store
        .dispatch(STORE_PREFIX + 'admin/recruiters/updateFilters', { [id]: value })
        .then(() => {
          this.fetch();
        });
    },

    delete_search_value(filter) {
      this.update_filters(filter.id, '');
      this.searchValues[filter.field] = '';
    },

    onPageChange(pageNumber) {
      this.$store.commit(STORE_PREFIX + 'admin/recruiters/updatePagination', {
        pageNumber
      });
      this.fetch();
    },

    onLimitChange(count) {
      this.$store.commit(STORE_PREFIX + 'admin/recruiters/updatePagination', {
        count
      });
      this.fetch();
    },

    toggle_add_user_modal(is_visible = false) {
      this.visible_add_user_modal = is_visible;

      if (!is_visible) {
        this.isInviteModalSuccess = false;
      }
    },

    add_user(user) {
      this.$store
        .dispatch(STORE_PREFIX + 'admin/recruiters/createRecruiter', {
          ...user,
          company: {
            id: this.companyId
          }
        })
        .then(() => this.fetch())
        .then(() => this.toggle_add_user_modal(false))
        .catch(err => this.$store.dispatch('global/setError', err));
    },

    inviteCompany({ email, language }) {
      const userId = this.currentUser ? this.currentUser.id : null;

      if (!userId) {
        return;
      }

      axios
        .post('v2/registration/invites', {
          company_id: this.companyId,
          email,
          language_code: language.code,
          user_id: userId,
          type: 'join_to_company'
        })
        .then(() => {
          // this.$noty.success('Приглашение успешно отправлено');
          // this.toggleInviteModalVisible(false);
          this.isInviteModalSuccess = true;
        })
        .catch(e => {
          let message = '';
          if (e && e.response && e.response.data && e.response.data.email) {
            message = this.$tr(`error.${Object.keys(e.response.data.email)[0]}`);
          } else {
            message = this.$tr('common.error');
          }
          this.$noty.error(message);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination:first-child {
  padding: 0 0 20px 0;
}

.content-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}

.actions-blocks {
  display: flex;
  align-items: center;
}

.actions-block {
  margin-left: 20px;
  position: relative;

  &:first-child {
    margin-left: 0;
  }
}

.scene-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.actions-block--name {
  position: relative;
}

.search-btn {
  position: absolute;
  z-index: 2;
  right: 8px;
  top: calc(50% - 7px);
}

.search-btn-submit {
  background: transparent;
  border: none;
  color: #aaa;
  font-size: 16px;
  cursor: pointer;
  margin-top: -3px;
}

.delete-term {
  position: relative;
  cursor: pointer;
  width: 15px;
  height: 15px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 6px;
    left: 0;
    display: block;
    width: 15px;
    height: 2px;
    border-radius: 2px;
    background-color: #545454;
    transition: opacity 0.2s;
  }

  &:before {
    transform: rotate(-45deg);
  }

  &:after {
    transform: rotate(45deg);
  }
}

.search-input {
  padding-right: 25px;
}
</style>
